import axios from 'axios'


export const getConsultations = ({commit,rootState}) => {
    axios.get(rootState.baseurl + '/fournisseurs/consultations/'+rootState.fournisseur.id,{
        headers:{
            "Content-Type":"application/json",
            "Authorization":"Bearer "+rootState.auth.token
        }
    }).then(res=>{
        console.log('Mes Consultations',res.data.data);
        commit('getConsultations',res.data.data);
    }).catch(()=>{
        console.log('error');
    });
}

export const getAppelOffre = ({commit,rootState}) => {
    axios.get(rootState.baseurl + '/offres/appels',{
        headers:{
            "Content-Type":"application/json",
            "Authorization":"Bearer "+rootState.auth.token
        }
    }).then(res=>{
        console.log('Appels d\'Offre',res.data.data);
        commit('getAppelOffre',res.data.data);
    }).catch(()=>{
        console.log('error');
    });
}
